import { faCalendarDays, faHeartPulse, faVenus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Button, Form, Image, Modal } from "react-bootstrap";
import { Circle, GirlImg } from "../../../../assets/images";

const PatientProfileModal = (props) => {
    return (
        <div>
            <Modal show={props.show} onHide={props.close} centered className="patient_profile_modal">
                <Modal.Header closeButton>
                    <Modal.Title>Patient Profile</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="patient_profile_area">
                        <div className="profile_detail">
                            <div className="left_area">
                                <div className="img_area">
                                    <Image src={GirlImg} alt="..." />
                                </div>
                            </div>
                            <div className="right_area">
                                <h3>Patient Name</h3>
                                <div className="text_list">
                                    <ul>
                                        <li>
                                            <div className="gender_area"><FontAwesomeIcon icon={faVenus} className="icon" />Female</div>
                                        </li>
                                        <li>
                                            <div className="label_area">Cardiology</div>
                                        </li>
                                        <li>
                                            <div className="general"><FontAwesomeIcon icon={faHeartPulse} className="icon_heart" />General</div>
                                        </li>
                                    </ul>
                                </div>
                                <div className="contact_area">
                                    <div className="left_con">
                                        <ul>
                                            <li>+91 898-898-7979</li>
                                            <li>+91 457-784-4545</li>
                                        </ul>
                                    </div>
                                    <div className="right_con">
                                        <div className="email">example@gmail.com</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="patient_information">
                            <div className="profile_info">
                                <div className="left_info">
                                    <div className="name">Father Name</div>
                                </div>
                                <div className="right_info">
                                    <div className="info">Jarnail Singh</div>
                                </div>
                            </div>
                            <div className="profile_info">
                                <div className="left_info">
                                    <div className="name">Mother Name</div>
                                </div>
                                <div className="right_info">
                                    <div className="info">Karam Kaur</div>
                                </div>
                            </div>
                            <div className="profile_info">
                                <div className="left_info">
                                    <div className="name">D.O.B</div>
                                </div>
                                <div className="right_info">
                                    <div className="info">12 June, 2023</div>
                                </div>
                            </div>
                            <div className="profile_info">
                                <div className="left_info">
                                    <div className="name">Age</div>
                                </div>
                                <div className="right_info">
                                    <div className="info">75</div>
                                </div>
                            </div>
                            <div className="profile_info">
                                <div className="left_info">
                                    <div className="name">Gender</div>
                                </div>
                                <div className="right_info">
                                    <div className="info">Male</div>
                                </div>
                            </div>
                            <div className="profile_info">
                                <div className="left_info">
                                    <div className="name">Blood Group</div>
                                </div>
                                <div className="right_info">
                                    <div className="info">B+</div>
                                </div>
                            </div>
                            <div className="profile_info">
                                <div className="left_info">
                                    <div className="name">Marital Status</div>
                                </div>
                                <div className="right_info">
                                    <div className="info">Married</div>
                                </div>
                            </div>
                            <div className="profile_info">
                                <div className="left_info">
                                    <div className="name">Occupation</div>
                                </div>
                                <div className="right_info">
                                    <div className="info">Diagnose Disease</div>
                                </div>
                            </div>
                            <div className="profile_info">
                                <div className="left_info">
                                    <div className="name">Nationality</div>
                                </div>
                                <div className="right_info">
                                    <div className="info">Indian</div>
                                </div>
                            </div>
                            <div className="profile_info">
                                <div className="left_info">
                                    <div className="name">House No.</div>
                                </div>
                                <div className="right_info">
                                    <div className="info">788/5</div>
                                </div>
                            </div>
                            <div className="profile_info">
                                <div className="left_info">
                                    <div className="name">District</div>
                                </div>
                                <div className="right_info">
                                    <div className="info">Punjab</div>
                                </div>
                            </div>
                            <div className="profile_info">
                                <div className="left_info">
                                    <div className="name">State</div>
                                </div>
                                <div className="right_info">
                                    <div className="info">Punjab</div>
                                </div>
                            </div>
                            <div className="profile_info">
                                <div className="left_info">
                                    <div className="name">City</div>
                                </div>
                                <div className="right_info">
                                    <div className="info">Jalandhar</div>
                                </div>
                            </div>
                            <div className="profile_info">
                                <div className="left_info">
                                    <div className="name">Address</div>
                                </div>
                                <div className="right_info">
                                    <div className="info">Plot no. 16, Punjab</div>
                                </div>
                            </div>
                            <div className="profile_info space_info">
                                <div className="left_info">
                                    <div className="name">Father Name</div>
                                </div>
                                <div className="right_info">
                                    <div className="info">Jarnail Singh</div>
                                </div>
                            </div>
                            <div className="circle_area">
                                <Image src={Circle} alt="..." />
                            </div>
                        </div>
                        <div className="btn_area">
                            <Button
                                className="cancelBtn"
                                type="button"
                            >
                                Cancel
                            </Button>
                            <Button
                                className="submitBtn"
                                type="button"
                            >
                                Edit Detail
                            </Button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default PatientProfileModal;